import type { NodeAndEdgeStatusEnum } from '@lighthouse/shared'
import styled, { css } from 'styled-components'

import { NODE_STATUS_COLOR, NODE_STATUS_SHADOW } from '../../constants'

export const NodeWrapper = styled.div<{ selected?: boolean; status?: NodeAndEdgeStatusEnum }>`
    border-width: 2px;
    border-style: solid;
    border-color: ${({ selected, status }) =>
        selected ? NODE_STATUS_COLOR[status || 'RUNNING'] : NODE_STATUS_COLOR[status || 'NOT_START']};
    border-radius: 12px;

    ${({ selected, status }) => {
        if (status) {
            return css`
                border-color: ${NODE_STATUS_COLOR[status]};
                box-shadow: ${selected ? `0px 0px 0px 4px ${NODE_STATUS_SHADOW[status]}` : 'none'};
            `
        }

        return css`
            border-color: ${selected ? 'var(--color-main)' : 'transparent'};
            &:hover {
                border-color: ${selected ? 'var(--color-main)' : '#D0DBF4'};
                box-shadow: 0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08);
            }
            &:hover .react-flow__handle::after {
                background-color: transparent;
            }
            &:hover .node-handle-wrapper {
                opacity: 1;
            }
        `
    }}
`
